import { GzGaugeWebComponent } from './component/GzGaugeWebComponent';
import { WEB_COMPONENT_GZ_GAUGE } from '../../webcomponents.constants';

export { GzGaugeWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_GAUGE, GzGaugeWebComponent);
